export function formatCurrency(formatNumber, value, currency) {
    const amount = formatNumber(value, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDisgits: 0
    });

    switch (currency) {
        case 'AUD':
            return `AU${amount}`;

        case 'NZD':
            return `NZ${amount}`;

        default:
            return amount;
    }
}
